export const isSafari = () => navigator.userAgent.toLowerCase().includes("safari")
